import type { FC } from 'react';
import type { BreadcrumbComponentProps } from 'use-react-router-breadcrumbs';

interface Props extends BreadcrumbComponentProps<'id'> {}

export const ChargerTestingSessionBreadcrumbValue: FC<Props> = ({ match }) => <>{match.params.id}</>;
